export default __webpack_public_path__ + "static/media/IntegrationWebsite.2242d56f.jpg";